module.exports = __webpack_public_path__ + "media/images/emblems/Corsier-sur-Vevey-coat_of_arms-aed97db644854fab8fc133629c6f7bc1.svg";